// import Cookies from "js-cookie"

export function getToken() {
  // return Cookies.get('token')
  return localStorage.getItem('token')
}

export function setToken(token) {
  // return Cookies.set('token', token)
  return localStorage.setItem('token', token)
}

export function getPicUrl() {
  // return Cookies.get('picUrl')
  return localStorage.getItem('picUrl')
}

export function setPicUrl(picUrl) {
  // return Cookies.set('picUrl', picUrl)
  return localStorage.setItem('picUrl', picUrl)
}
